module.exports = __webpack_public_path__ + "img/inp_mail.ce1f4208.png";